import {
  CardBtnArrowIcon,
  CarouselNavDirection,
  CarouselNavPagers,
} from '@jouzen/ecom-components';

import HeroCarouselNavPagerDot from './HeroCarouselNavPagerDot';

const directionClasses =
  'flex items-center justify-center size-4 text-sandstone-200 pt-px';

const Previous = () => {
  return (
    <CarouselNavDirection className={directionClasses} direction="backwards">
      <CardBtnArrowIcon className="scale-x-[-1]" width="10" />
    </CarouselNavDirection>
  );
};

const Next = () => {
  return (
    <CarouselNavDirection className={directionClasses} direction="forwards">
      <CardBtnArrowIcon width="10" />
    </CarouselNavDirection>
  );
};

const HeroCarouselNav = () => {
  return (
    <div className="absolute bottom-6 flex h-[18px] items-center gap-x-2 rounded-xl bg-gray-600/20 px-3 backdrop-blur-xs max-md:left-1/2 max-md:-translate-x-1/2 md:right-6 md:px-1.5 lg:right-8 lg:bottom-8">
      <Previous />
      <CarouselNavPagers
        className="gap-x-2"
        CustomPagerDot={HeroCarouselNavPagerDot}
      />
      <Next />
    </div>
  );
};

export default HeroCarouselNav;
